<div class="modal-overlay">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-left">
        <img src="assets/home/shared/boat_icon_dark.svg" class="header-icon" alt="" />
        <h3>Throw lines</h3>
      </div>
      <app-exit-button ariaLabel="Close throw lines" (clicked)="onCancel()"></app-exit-button>
    </div>

    <div class="modal-body">
      <div class="form-group" [appTourAnchor]="'tl.name'">
        <label>Name</label>
        <input type="text" [(ngModel)]="name" />
      </div>
      <div class="form-group">
        <label>Description</label>
        <input type="text" [(ngModel)]="description" />
      </div>

      <p class="section-title">Who can view this trip?*</p>

      <div class="privacy-options" [appTourAnchor]="'tl.privacy'">

        <!-- Everyone -->
        <div class="option"
          [class.selected]="selectedPrivacy === 'public' && !disableEveryoneOption"
          [class.disabled]="disableEveryoneOption"
          (click)="selectPrivacy('public')">
          <div class="option-left">
            <img src="assets/trip/everyone_icon.svg" class="privacy-icon" />
            <div>
              <div class="option-name" [class.muted]="disableEveryoneOption">The Water (Everyone)</div>
              <div class="option-desc">Anyone on Vector can view this journey in feed or search</div>
              <div class="disabled-reason" *ngIf="disableEveryoneOption">
                Unavailable while shared to a restrictive fleet
              </div>
            </div>
          </div>
          <div class="radio-circle" [class.selected-circle]="selectedPrivacy === 'public' && !disableEveryoneOption"></div>
        </div>

        <!-- Private -->
        <div class="option"
          [class.selected]="selectedPrivacy === 'private'"
          (click)="selectPrivacy('private')">
          <div class="option-left">
            <img src="assets/trip/private_icon.svg" class="privacy-icon" />
            <div>
              <div class="option-name">Private (Only Me)</div>
              <div class="option-desc">This Journey is private, its only for your own purposes.</div>
            </div>
          </div>
          <div class="radio-circle" [class.selected-circle]="selectedPrivacy === 'private'"></div>
        </div>

        <!-- Dockmates -->
        <div class="option"
          [class.selected]="selectedPrivacy === 'dockmates'"
          (click)="selectPrivacy('dockmates')">
          <div class="option-left">
            <img src="assets/trip/dockmates_icon.svg" class="dockmates-icon" />
            <div>
              <div class="option-name">Dockmates</div>
              <div class="option-desc">Select specific followers or groups who can view this journey.</div>
            </div>
          </div>
          <div class="radio-circle" [class.selected-circle]="selectedPrivacy === 'dockmates'"></div>
        </div>

      </div>

      <!-- Search -->
      <div class="search-box" *ngIf="selectedPrivacy === 'dockmates'">
        <img src="assets/home/profile/searchicon.svg" class="search-icon" />
        <input type="text" placeholder="Search Dockmates & Fleets" [(ngModel)]="visibilitySearchQuery" />
      </div>

      <!-- Loading -->
      <div class="loading-row" *ngIf="selectedPrivacy === 'dockmates' && loadingRecipients">
        <div class="spinner"></div>
        <span>Loading...</span>
      </div>

      <!-- Recipients list -->
      <div class="selected-groups" *ngIf="selectedPrivacy === 'dockmates' && !loadingRecipients">

        <!-- Fleets Section -->
        <div class="group-section" *ngIf="filteredFleets.length > 0">
          <p class="section-subtitle">Fleets</p>

          <div class="group-item"
            *ngFor="let fleet of filteredFleets; let i = index"
            [class.item-disabled]="isDisabled(fleetKeyIndex(fleets.indexOf(fleet)))"
            (click)="!isDisabled(fleetKeyIndex(fleets.indexOf(fleet))) && onToggle(fleetKeyIndex(fleets.indexOf(fleet)))">

            <!-- Checkbox -->
            <div class="custom-checkbox"
              [class.checked]="isChecked(fleetKeyIndex(fleets.indexOf(fleet)))"
              [class.cb-disabled]="isDisabled(fleetKeyIndex(fleets.indexOf(fleet)))">
              <svg *ngIf="isChecked(fleetKeyIndex(fleets.indexOf(fleet)))"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>

            <!-- Avatar -->
            <div class="group-avatar fleet-avatar"
              [style.opacity]="isDisabled(fleetKeyIndex(fleets.indexOf(fleet))) ? '0.5' : '1'">
              <img *ngIf="fleet.image_url" [src]="fleet.image_url" alt="" />
              <span *ngIf="!fleet.image_url">{{ getInitials(fleet.name) }}</span>
            </div>

            <!-- Info -->
            <div class="item-info"
              [style.opacity]="isDisabled(fleetKeyIndex(fleets.indexOf(fleet))) ? '0.55' : '1'">
              <span class="item-name">{{ fleet.name }}</span>
              <span class="restrictive-badge" *ngIf="fleet.isRestrictive">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                  fill="none" stroke="#B25A00" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                Restrictive fleet
              </span>
              <span class="item-subtitle" *ngIf="fleet.membersCount > 0">{{ fleet.membersCount }} members</span>
              <span class="locked-label" *ngIf="isDisabled(fleetKeyIndex(fleets.indexOf(fleet)))">
                Locked by restrictive fleet
              </span>
            </div>

          </div>
        </div>

        <!-- Dockmates Section -->
        <div class="group-section" *ngIf="filteredDockmates.length > 0">
          <p class="section-subtitle">Pier Circle (Dockmates)</p>

          <div class="group-item"
            *ngFor="let mate of filteredDockmates; let i = index"
            [class.item-disabled]="isDisabled(dmKeyIndex(dockmates.indexOf(mate)))"
            (click)="!isDisabled(dmKeyIndex(dockmates.indexOf(mate))) && onToggle(dmKeyIndex(dockmates.indexOf(mate)))">

            <!-- Checkbox -->
            <div class="custom-checkbox"
              [class.checked]="isChecked(dmKeyIndex(dockmates.indexOf(mate)))"
              [class.cb-disabled]="isDisabled(dmKeyIndex(dockmates.indexOf(mate)))">
              <svg *ngIf="isChecked(dmKeyIndex(dockmates.indexOf(mate)))"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>

            <!-- Avatar -->
            <div class="group-avatar"
              [style.opacity]="isDisabled(dmKeyIndex(dockmates.indexOf(mate))) ? '0.5' : '1'">
              <img *ngIf="mate.image_url" [src]="mate.image_url" alt="" />
              <span *ngIf="!mate.image_url">{{ getInitials(mate.name) }}</span>
            </div>

            <!-- Info -->
            <div class="item-info"
              [style.opacity]="isDisabled(dmKeyIndex(dockmates.indexOf(mate))) ? '0.55' : '1'">
              <span class="item-name">{{ mate.name }}</span>
              <span class="item-subtitle" *ngIf="mate.vesselName">{{ mate.vesselName }}</span>
              <span class="locked-label" *ngIf="isDisabled(dmKeyIndex(dockmates.indexOf(mate)))">
                Locked by restrictive fleet
              </span>
            </div>

          </div>
        </div>

        <!-- Empty state -->
        <div class="empty-state"
          *ngIf="filteredFleets.length === 0 && filteredDockmates.length === 0">
          <span>{{ visibilitySearchQuery ? 'No matches found' : 'No dockmates or fleets yet' }}</span>
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="update-btn" [appTourAnchor]="'tl.start'" (click)="onThrowLines()">Throw lines</button>
    </div>
  </div>
</div>

<lib-snackbar [message]="snackbarMessage" [type]="snackbarType" [show]="showSnackbar" [duration]="4000"
  [autoClose]="true" [theme]="'light'" (onClose)="onSnackbarClose()"
  (onAutoClose)="onSnackbarAutoClose()"></lib-snackbar>
